import Stack from 'assets/js/stack'
const commonFn = {
  j2s(obj) {
    return JSON.stringify(obj)
  },
  s2j(obj) {
    return JSON.parse(obj)
  },
  goBack() {
    router.go(-1)
  },
  toastMsg(obj, type, msg) {
    switch (type) {
      case 'normal':
        obj.$message(msg)
        break
      case 'success':
        obj.$message({
          message: msg,
          type: 'success',
          duration: 1500
        })
        break
      case 'warning':
        obj.$message({
          message: msg,
          type: 'warning',
          duration: 1500
        })
        break
      case 'error':
        // obj.$message.error(msg)
        // 缩短提示时间
        obj.$message({
          message: msg,
          type: 'error',
          duration: 1500
        })
        break
    }
  },
  clearVuex(cate) {
    store.dispatch(cate, [])
  },
  showJsonData(target) {
    console.log('target = ', this.j2s(target))
  },
  dealError(obj, res) {
    switch (res.code) {
      case 101:
        // 当失效时，清空cookies中的tokenKey,防止其他设备自动登录
        Cookies.remove('tokenKey')
        if (Cookies.get('rememberPwd')) {
          let data = {
            rememberKey: Lockr.get('rememberKey')
          }
          this.reAjax('base/relogin', data).then((res) => {
            if (res.code == 200) {
              this.resetCommonData(obj, res.data)
            } else {
              this.toastMsg(obj, 'error', res.error)
            }
          })
        } else {
          this.toastMsg(obj, 'error', res.error)
          setTimeout(() => {
            router.replace('/')
          }, 1500)
        }
        break
      case 103:
        this.toastMsg(obj, 'error', res.error)
        setTimeout(() => {
          router.replace('/')
        }, 1500)
        break
      default :
        this.toastMsg(obj, 'error', res.error)
    }
  },
  catchError(obj, func, msg) {
    try {
      func()
    } catch (e) {
      console.error('error in compoment: ' + obj.componentName)
      console.error(e)
      if (!msg) {
        msg = '系统异常，请联系开发人员进行修复'
      }
      this.toastMsg(obj, 'error', msg)
      return true
    }
    return false
  },
  dataTypeError(obj, duck, data, msg) {
    return this.catchError(obj, () => {
      let result = duck.errors(data)
      if (result != false) {
        console.error(result)
        throw new Error('数据类型不正确！')
      }
    }, msg)
  },
  getHasRule(val) {
    const moduleRule = 'admin'
    let userInfo = Lockr.get('userInfo')
    if (userInfo.id === 0) {
      return true
    } else {
      let authList = moduleRule + Lockr.get('authList')
      return _.includes(authList, val)
    }
  },
  reAjax(url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (response) => {
        reject(response)
        alert('连接超时，请检查网络连接')
      })
    })
  },
  resetCommonData(obj, data) {
    _(data.menusList).forEach((res, key) => {
      if (key == 0) {
        res.selected = true
      } else {
        res.selected = false
      }
    })
    Lockr.set('menus', data.menusList)              // 菜单数据
    Lockr.set('menusThreeList', data.menusThreeList)// 三级菜单数据
    Lockr.set('rememberKey', data.rememberKey)      // 记住密码的加密字符串
    Lockr.set('authList', data.authList)            // 权限节点列表
    Lockr.set('userInfo', data.userInfo)            // 用户信息
    Lockr.set('token', data.token)                  // 接口认证凭证
    const time = (new Date()).getTime()
    var base64 = window.btoa(time)
    var token = Lockr.get('token') + '%' + base64
    window.axios.defaults.headers.token = token
    // 记住token，不改密码7天可自动登录
    Cookies.set('tokenKey', Lockr.get('token'), { expires: 7 })
    let routerUrl = this.getExistMenuUrl(data.menusList)
    if (routerUrl) {
      setTimeout(() => {
        let path = obj.$route.path.slice(1)
        if (routerUrl != path) {
          router.replace(routerUrl)
        } else {
          location.reload()
        }
      }, 1000)
    } else {
      _g.toastMsg(obj, 'error', '系统菜单出错')
    }
  },
  getExistMenuUrl(arr) {
    let routerUrl = null
    _(arr).forEach((item) => {
      if (!item.child && item.url) {
        routerUrl = item.url
        store.dispatch('showLeftMenu', true)
        return false
      } else if (item.child && item.child.length) {
        routerUrl = this.getExistMenuUrl(item.child)
        if (routerUrl) {
          store.dispatch('showLeftMenu', false)
          return false
        }
      }
    })
    return routerUrl
  },
  reloadPage(obj) {
    let toParams = {
      name: obj.$route.name,
      params: obj.$route.params,
      query: obj.$route.query
    }
    router.replace({ name: 'reload', params: toParams })
  },
  updateMenus() {
    store.dispatch('updateMenusList')
  },
  parseFormula(value) { // 解析时间公式
    if (value) {
      let valueTrim = value.trim().replace(/\s/g, '') // 去空格
      let formulaArr = valueTrim.split('&')
      let result = moment(new Date())
      _(formulaArr).forEach((formula) => {
        let hasPlus = formula.indexOf('+') > -1
        let hasMinus = formula.indexOf('-') > -1
        let unit = ''
        if (formula.indexOf('Y') > -1) { // 年
          unit = 'years'
        } else if (formula.indexOf('M') > -1) { // 月
          unit = 'months'
        } else if (formula.indexOf('D') > -1) { // 日
          unit = 'days'
        } else if (formula.indexOf('h') > -1) { // 时
          unit = 'hours'
        } else if (formula.indexOf('m') > -1) { // 分
          unit = 'minutes'
        } else if (formula.indexOf('s') > -1) { // 秒
          unit = 'seconds'
        }
        if (unit) {
          let splitResult = ''
          let number = 0
          let times = 1
          if (hasPlus) {
            splitResult = formula.split('+')
            times = 1
          } else if (hasMinus) {
            splitResult = formula.split('-')
            times = -1
          }
          if (hasPlus || hasMinus) {
            _(splitResult).forEach((res) => { // 遍历切割的数组，把数字减掉
              if ((/^[0-9\.]+$/g).test(res)) {
                number += parseFloat(res) * times
              }
            })
          }
          result.add(number, unit)
        }
      })
      return new Date(result)
    } else {
      return ''
    }
  },
  updateHttpHeader() { // 更新http头部信息
    let headerObject = {}
    // 给当前token加上当前时间，base解析
    let base64 = window.btoa((new Date()).getTime())
    let token = Lockr.get('token') + '%' + base64
    // 组成对象数据返回
    headerObject.token = token
    if (!_g.isRealEmpty(store.state.projectId)) {
      headerObject.projectid = store.state.projectId
      headerObject.envcode = store.state.projectEnvCode
      headerObject.version = store.state.urlVersion
    }
    return headerObject
  },
  isRealEmpty(value) { // 判断是否真的为空
    // value为以下值时返回true：undefined,null,'',空数组,空对象
    return value === '' ||
           _.isUndefined(value) ||
           _.isNull(value) ||
           ((_.isArray(value) || _.isObject(value)) && _.isEmpty(value))
  },
  moveUpOrDown(arr, index, index2) { // 上移 下移 index < index2 下移 index > index2 上移
    let tempArr = arr
    // 第三个参数 向数组添加的新项目
    tempArr[index] = tempArr.splice(index2, 1, tempArr[index])[0]
    return tempArr
  },
  /**
   * [handleCompute 执行浮点数四则运算]
   * @param  {[Number]} a         [前置算数]
   * @param  {[Number]} b         [后置算数]
   * @param  {[String]} type      [运算类型（+、-、*、／）]
   * @return {[Number]} result    [运算结果]
   */
  handleCompute(a, b, type) {
    // js浮点数运算有bug，需转化成整形数运算再还原
    let result = 0
    let multiA = 1
    let multiB = 1
    if (!_g.isRealEmpty(a) && a.toString().indexOf('.') > -1) {
      let string = Math.abs(a).toString().replace(/\d+./, '')
      if (string) {
        multiA *= Math.pow(10, string.length)
      }
    }
    if (!_g.isRealEmpty(b) && b.toString().indexOf('.') > -1) {
      let string = Math.abs(b).toString().replace(/\d+./, '')
      if (string) {
        multiB *= Math.pow(10, string.length)
      }
    }
    let multi = Math.max(multiA, multiB)
    if (multiA == 1) {
      a *= multi
    } else {
      a = parseFloat(a.toString().replace('.', ''))
      a = a * multi / multiA
    }
    if (multiB == 1) {
      b *= multi
    } else {
      b = parseFloat(b.toString().replace('.', ''))
      b = b * multi / multiB
    }
    switch (type) {
      case '+':
        result = (a + b) / multi
        break
      case '-':
        result = (a - b) / multi
        break
      case '*':
        result = (a * b) / (multi * multi)
        break
      case '/':
        result = a / b
        break
    }
    return result
  },
  setTimeDistance(timeDistance) {
    store.dispatch('setTimeDistance', timeDistance)
  },
  setHasHistory() {
    store.dispatch('setHasHistory')
  },
  setFrontRoute(url) {
    store.dispatch('setFrontRoute', url)
  },
  setDocumentTitle(title) {
    store.dispatch('setDocumentTitle', title)
  },
  alertMsg(obj, type, msg) {
    switch (type) {
      case 'normal':
        obj.$alert(msg, '提示')
        break
      case 'success':
        obj.$alert(msg, '提示', {
          type: 'success'
        })
        break
      case 'warning':
        obj.$alert(msg, '提示', {
          type: 'warning'
        })
        break
      case 'error':
        // 缩短提示时间
        obj.$alert(msg, '提示', {
          type: 'error'
        })
        break
    }
  },
  confirmMsg(obj, type, msg, successCb, confirmText = '确定', cancelText = '取消', confirmClass = '', cancelClass = '') {
    obj.$confirm(msg, '提示', {
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      confirmButtonClass: confirmClass,
      cancelButtonClass: cancelClass,
      type: type
    }).then(() => {
      if (successCb) {
        successCb()
      }
    })
  },
  parseToTimeStamp(value) { // 转化为时间戳（毫秒）
    let stamp = moment(value).unix()
    if (isNaN(stamp)) {
      stamp = ''
    } else {
      stamp *= 1000
    }
    return stamp
  },
  /**
   * [getServerTimeStamp 转化时间为服务器时间]
   * @param  {[String/Number]} time [传入时间]
   * @return {[Number]}      [时间戳（毫秒）]
   */
  getServerTimeStamp(time) {
    let date = null
    if (!this.isRealEmpty(time)) {
      date = new Date(time)
    } else {
      date = new Date()
    }
    if (date === 'Invalid Date') {
      date = new Date()
    }
    let result = this.parseToTimeStamp(date) + store.state.timeDistance * 1000
    return result
  },
  fixBase64(value) {  // 不知为何+号会变成空格，转码回来
    return value.replace(/\s/g, '+')
  },
  checkHost(url) { // 检查链接的域名是否是当前域名
    return url.indexOf(imgUrl) > -1 || url.indexOf(HOST) > -1
  },
  toastMsgForForm(obj) {
    this.alertMsg(obj, 'error', '请检查填入数据')
  },
  interceptionRouter(query) {
    let obj = {}
    if (query) {
      let arr = query.split('&')
      _(arr).forEach((res) => {
        obj[res.split('=')[0]] = res.split('=')[1]
      })
    }
    return obj
  },
  resetCurIndexByCut(cutData, currentIndex, insertIndex) { // 重置当前选中的项（因剪切导致的改动）
    let findCut = false
    let front = 0
    let back = 0
    _(cutData).forEach((res, key) => {
      if (currentIndex == res.cutIndex) {
        if (currentIndex > insertIndex) {   // 如果当前配置项在插入项后，需要加一
          currentIndex = key - cutData.length + insertIndex + 2
        } else if (currentIndex < insertIndex) { // 如果当前配置项在插入项前
          currentIndex = key - cutData.length + insertIndex + 1
        }
        findCut = true
        return false
      } else if (currentIndex > res.cutIndex) { // 如果剪切项在当前配置的项的前
        front++
      } else if (currentIndex < res.cutIndex) { // 如果剪切项在当前配置的项的后
        back++
      }
    })
    if (!findCut) {
      if (currentIndex > insertIndex) {   // 如果当前配置项在插入项后，只受后方项数量影响
        currentIndex += back
      } else if (currentIndex <= insertIndex) { // 如果当前配置项在插入项前或者相同，只受前方项数量影响
        currentIndex -= front
      }
    }
    return currentIndex
  },
  getSystemVersion() { // 检查系统当前版本号
    let version = store.state.version
    if (!this.isRealEmpty(version)) {
      version = 'v' + version.replace(/\./g, '')
    }
    return version
  },
  routerPush(route) { // 页面跳转
    let version = this.getSystemVersion()
    if (route.path && !this.isRealEmpty(version)) {
      route.path += `/${version}`
    }
    router.push(route)
  },
  /**
   * [getVersionByUrl 获取url上的版本号）]
   * @param  {[String]} path    [路径]
   * @return {[String]} version [版本号，格式x.x.x，如0.0.1]
   */
  getVersionByUrl(path) {
    let version = ''
    if (((/v\d{3}/)).test(path)) {
      let index = path.search((/v\d{3}/))
      version = path.substr(index, 4).replace('v', '').split('').join('.')
    }
    return version
  },
  /**
   * [setUrlVersion 设置url的版本号（用于自动修正）]
   * @param  {[String]} path [路径]
   * @param  {[String]} version [版本号，格式x.x.x，如0.0.1]
   * @param  {[String]} query [查询数据，如?id=1]
   * @return {[Number]} path [版本号替换后的路径]
   */
  setUrlVersion(path, version, query) {
    if (path) {
      let realVersion = 'v' + version.replace(/\./g, '')
      if ((/v\d{3}/).test(path)) {
        path = path.replace((/v\d{3}/), realVersion)
      } else if (version != store.state.mostNewVersion) {
        path += `/${realVersion}`
      }
    }
    if (query) {
      path += query
    }
    return path
  },
  setProjectInfo(projectId, projectEnvCode) { // 设置项目相关信息
    store.dispatch('setProjectInfo', { projectId: projectId, envCode: projectEnvCode })
  },
  getOnlyKey() { // 获取唯一key
    return `key_${moment().unix()}_${parseInt(Math.random() * 1000) * parseInt(Math.random() * 1000)}`
  },
  // addDialog(component, title, props, events, width = 1200, height = 500) { // 添加一个弹窗，返回弹窗的key
  addDialog(component, title, props, events, meta) { // 添加一个弹窗，返回弹窗的key
    let key = this.getOnlyKey()
    let dialog = {
      key,
      component,
      title,
      props,
      events,
      meta
    }
    store.dispatch('addDialog', dialog)
    return key
  },
  changeMoneyToChinese(obj, money) {
    let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'] // 汉字的数字
    let cnIntRadice = ['', '拾', '佰', '仟'] // 基本单位
    let cnIntUnits = ['', '万', '亿', '兆']// 对应整数部分扩展单位
    let cnDecUnits = ['角', '分', '毫', '厘'] // 对应小数部分单
    // let cnInteger = "整" // 整数金额时后面跟的字符
    let cnIntLast = '元' // 整型完以后的单位
    let maxNum = 999999999999999.9999 // 最大处理的数字
    let IntegerNum // 金额整数部分
    let DecimalNum // 金额小数部分
    let ChineseStr = '' // 输出的中文金额字符串
    let parts // 分离金额后用的数组，预定义
    let intLen
    if (money == '') {
      return ''
    }
    money = parseFloat(money)
    if (money >= maxNum) {
      this.toastMsg(obj, 'info', '超出最大处理数字')
      return ''
    }
    if (money == 0) {
      // ChineseStr = cnNums[0]+cnIntLast+cnInteger
      ChineseStr = cnNums[0] + cnIntLast
      // document.getElementById("show").value=ChineseStr
      return ChineseStr
    }
    money = money.toString() // 转换为字符串
    if (money.indexOf('.') == -1) {
      IntegerNum = money
      DecimalNum = ''
    } else {
      parts = money.split('.')
      IntegerNum = parts[0]
      DecimalNum = parts[1].substr(0,4)
    }
    if (parseInt(IntegerNum, 10) > 0) { // 获取整型部分转换
      let zeroCount = 0
      // let intLen = IntegerNum.length
      for (let i = 0; i < IntegerNum.length; i++) {
        let n = IntegerNum.substr(i,1)
        let p = IntegerNum.length - i - 1
        let q = p / 4
        let m = p % 4
        if (n == '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            ChineseStr += cnNums[0]
          }
          zeroCount = 0 // 归零
          ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
        if (m == 0 && zeroCount < 4) {
          ChineseStr += cnIntUnits[q]
        }
      }
      ChineseStr += cnIntLast
      // 整型部分处理完毕
    }
    if (DecimalNum != '') { // 小数部分
      for (let i = 0; i < DecimalNum.length; i++) {
        let n = DecimalNum.substr(i, 1)
        if (n != '0') {
          ChineseStr += cnNums[Number(n)] + cnDecUnits[i]
        }
      }
    }
    if (ChineseStr == '') {
      // ChineseStr += cnNums[0]+cnIntLast+cnInteger
      ChineseStr += cnNums[0] + cnIntLast
    }
    /* else if( DecimalNum == '' ){
        ChineseStr += cnIntegerChineseStr += cnInteger
    } */
    return ChineseStr
  },
  clearLoginInfo() {  // 退出登录后清理本地缓存数据
    Lockr.rm('menus')
    Lockr.rm('menusThreeList')
    Lockr.rm('rememberKey')
    Lockr.rm('authList')
    Lockr.rm('userInfo')
    Lockr.rm('isCloud')
    Lockr.rm('projectId')
    Lockr.rm('envCode')
    Cookies.remove('tokenKey')
  },
  /**
   * [handleTimeCompute 执行时间计算]
   * @param  {[Number]} a         [前置算数，格式：HH:mm]
   * @param  {[Number]} b         [后置算数，格式：HH:mm]
   * @param  {[String]} type      [运算类型（+、-）]
   * @param  {[String]} isFormat  [是否转化为间隔标准时间，若为true，则09:21+00:30=09:30, 09:31+00:30=10:00；若为false，则09:21+00:30=09:51
   * ]
   * @return {[Number]} result    [运算结果，格式HH:mm]
   */
  handleTimeCompute(a, b, type, isFormat) {
    let result = ''
    let regExp = /^\d{2}\:\d{2}$/
    if (regExp.test(a) && regExp.test(b)) {
      let aArr = a.split(':')
      let aHour = aArr[0]
      let aMin = aArr[1]
      let bArr = b.split(':')
      let bHour = bArr[0]
      let bMin = bArr[1]
      let aAllMin = parseFloat(aHour) * 60 + parseFloat(aMin)
      let bAllMin = parseFloat(bHour) * 60 + parseFloat(bMin)
      let sumMin = 0
      if (!isFormat) {
        switch (type) {
          case '+':
            sumMin = aAllMin + bAllMin
            break
          case '-':
            sumMin = aAllMin - bAllMin
            break
        }
      } else {
        let least = aAllMin % bAllMin
        switch (type) {
          case '+':
            sumMin = aAllMin + bAllMin - least
            break
          case '-':
            sumMin = aAllMin - least
            break
        }
      }
      if (sumMin >= 24 * 60) {  // 若超过了23:59，则重置为00:00
        sumMin = 0
      }
      let resultHour = parseInt(sumMin / 60)
      let resultMin = parseInt(sumMin % 60)
      if (resultHour < 10) {
        resultHour = '0' + resultHour
      }
      if (resultMin < 10) {
        resultMin = '0' + resultMin
      }
      result = `${resultHour}:${resultMin}`
    }
    return result
  },
  /**
   * [vaildTime 验证是否时间格式]
   * @param  {[String]} value [需要验证的值]
   * @param  {[String]} unit  [单位]
   * @return {[Boolean]}       [验证结果]
   */
  vaildTime(value, unit) {
    if (unit == 'm') {
      // 验证格式：00:00
      return (/^\d{2}\:\d{2}$/).test(value)
    } else if (unit == 's') {
      // 验证格式：00:00:00
      return (/^\d{2}\:\d{2}\:\d{2}$/).test(value)
    }
  },
  /**
   * [parseFormula 解析公式]
   * @param  {[String]} str [数学公式]
   * @return {[Array]}     [解析成后缀表达式的公式数组]
   */
  parseMathFormula(str) { // 解析数学公式
    str = str.replace(/\s/g, '').replace(/\"/g, '')
    var stack = new Stack.Stack()
    var outStack = []
    var cutIndex = 0
    for (var i = 0; i < str.length; ++i) {
      if (str[i] == ')') {
        let cut = str.substring(cutIndex, i)
        if (cut) {
          outStack[outStack.length] = cut
        }
        cutIndex = i + 1
        while (true) {
          var top = stack.peek()
          stack.pop()
          if (top != '(') {
            outStack[outStack.length] = top
          } else {
            break
          }
        }
      } else if (['-','+'].indexOf(str[i]) > -1) {
        let cut = str.substring(cutIndex, i)
        if (cut) {
          outStack[outStack.length] = cut
        }
        cutIndex = i + 1
        if (['*','/'].indexOf(stack.peek()) > -1) {
          while (['*','/'].indexOf(stack.peek()) > -1) {
            outStack[outStack.length] = stack.peek()
            stack.pop()
          }
          // outStack[outStack.length] = str[i]
        } else if (['+','-'].indexOf(stack.peek()) > -1) {
          while (['+','-'].indexOf(stack.peek()) > -1) {
            outStack[outStack.length] = stack.peek()
            stack.pop()
          }
        }
        stack.push(str[i])
      } else if (['(','*','/'].indexOf(str[i]) > -1) {
        let cut = str.substring(cutIndex, i)
        if (cut) {
          outStack[outStack.length] = cut
        }
        cutIndex = i + 1
        stack.push(str[i])
      }
      if (i == str.length - 1) {
        let cut = str.substring(cutIndex, str.length)
        if (cut) {
          outStack[outStack.length] = (cut)
        }
      }
    }
    while (stack.length()) {
      outStack[outStack.length] = stack.pop()
    }
    return outStack
  },
  /**
   * [contentJumpLink 用于统一处理通用模型的跳转问题]
   * @param  {[Object]} route    [路由对象，包含以下参数]
   * @param  {[Object]} obj    [vue组件实例对象]
   * @param  {[String]} path   [路由url，不与name和params同时生效]
   * @param  {[String]} name   [路由名]
   * @param  {[Object]} params [路由params]
   * @param  {[Object]} query  [路由query]
   */
  contentJumpLink(route) {
    if (route) {
      let pageId = ''
      if (route.obj) {
        if (route.obj.$route.query.pageId) {
          pageId = route.obj.$route.query.pageId
        } else if (route.obj.$route.params.contentId) {
          pageId = route.obj.$route.params.contentId
        }
      }
      if (pageId) {
        if (route.query) {
          route.query.pageId = pageId
        } else {
          route.query = { pageId: pageId }
        }
      }
      router.push(route)
    }
  },
  /**
   * [contentJumpLink 用于统一处理通用模型的打开新窗口问题]
   * @param  {[Object]} route    [路由对象，包含以下参数]
   * @param  {[Object]} obj    [vue组件实例对象]
   * @param  {[String]} path   [路由url]
   */
  contentOpenLink(route) {
    if (route) {
      let pageId = ''
      if (route.obj) {
        if (route.obj.$route.query.pageId) {
          pageId = route.obj.$route.query.pageId
        } else if (route.obj.$route.params.contentId) {
          pageId = route.obj.$route.params.contentId
        }
      }
      let url = route.path
      if (pageId && url && url.indexOf('pageId') == -1) {
        if (url.indexOf('?') > -1) {
          url += `&pageId=${pageId}`
        } else {
          url += `?pageId=${pageId}`
        }
      }
      window.open(url, '_blank')
    }
  },
  /**
   * [contrastArrayObj 两个数组对象的交并集]
   * @param  Array[object] arrObjOne    [第一个数组对象]
   * @param  Array[object] arrObjTwo    [第二个数组对象]
   * @param  [String] params    [对象中对比的key]
   * @param  [Boolean]isSame  [决定取交集还是并集,true为交集,false为并集]
   */
  contrastArrayObj(arrObjOne, arrObjTwo, params, isSame) {
    let oneParamArr = []
    let twoParamArr = []
    let result = []
    _(arrObjOne).forEach((obj) => {
      _(obj).forEach((val, key) => {
        if (key == params) {
          oneParamArr.push(val)
        }
      })
    })
    _(arrObjTwo).forEach((obj) => {
      _(obj).forEach((val, key) => {
        if (key == params) {
          twoParamArr.push(val)
        }
      })
    })
    if (isSame) {
      // 交集
      let arr = []
      _(oneParamArr).forEach((res) => {
        if (_.indexOf(twoParamArr, res) > -1) {
          arr.push(res)
        }
      })
      _(arrObjOne).forEach((obj) => {
        _(obj).forEach((val, key) => {
          if (key == params) {
            if (_.indexOf(arr, val) > -1) {
              result.push(obj)
            }
          }
        })
      })
    } else {
      // 并集
      let arr1 = []
      let arr2 = []
      let diffArr = []
      arr1 = _.difference(oneParamArr, twoParamArr)
      arr2 = _.difference(twoParamArr, oneParamArr)
      diffArr = arr1.concat(arr2)
      _(arrObjOne).forEach((obj) => {
        _(obj).forEach((val, key) => {
          if (key == params) {
            if (_.indexOf(diffArr, val) > -1) {
              result.push(obj)
            }
          }
        })
      })
      _(arrObjTwo).forEach((obj) => {
        _(obj).forEach((val, key) => {
          if (key == params) {
            if (_.indexOf(diffArr, val) > -1) {
              result.push(obj)
            }
          }
        })
      })
    }
    return result
  }
}
export default commonFn



// WEBPACK FOOTER //
// ./src/assets/js/global.js